import {useEffect, useState} from "react";
import {getPrivacyPolicy} from "../../Api/privacyPolicy";

const PrivacyPolicy = () => {
    const [data, setData] = useState(undefined);

    useEffect(() => {
        getPrivacyPolicy().then((response) => {
            setData(response.data.data[0].fields);
        });
    }, [])

    if (data === undefined) return (<div>Loading...</div>);
    return (
        <div className="mx-auto w-5/6 pt-32">
            <div dangerouslySetInnerHTML={{ __html: data.content}} />
        </div>
    );
}

export default PrivacyPolicy;
